import PropTypes from 'prop-types';

export const MyCarsDataPropTypes = PropTypes.shape({
	accountID: PropTypes.string.isRequired,
	userID: PropTypes.string.isRequired,
	newSaveCount: PropTypes.number.isRequired,
	newTrackedPriceCount: PropTypes.number.isRequired,
	vehicles: PropTypes.arrayOf(PropTypes.object)
});
